/**
 * A reserva do polling do portal (D3, passo 19 — PR 2): o polling de 30 s do sino vira reserva e pausa enquanto o socket está vivo.
 * ⚠️ Só `mode === "ws"` conta: no portal não existe SSE, e `connecting`/`disconnected` são justamente os momentos em que o polling
 * precisa estar de pé. O valor entra no `refetchInterval` como número/`false` (não função): o `useTransportMode` re-renderiza o
 * componente a cada mudança de modo e o observador reajusta o intervalo na mesma hora.
 */
import { useTransportMode } from "@/lib/realtime-store";

export const INTERVALO_DE_RESERVA_MS = 30_000;

export function usePortalSocketVivo(): boolean {
  return useTransportMode() === "ws";
}

export function intervaloDeReserva(
  socketVivo: boolean,
  ms: number = INTERVALO_DE_RESERVA_MS
): number | false {
  return socketVivo ? false : ms;
}
